import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes, PropType } from "vue";
export const xDatePiker = buildProps({
  type: {
    type: String,
  },
  shortcutsConfig: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
} as const);

export type xDatePiker = ExtractPropTypes<typeof xDatePiker>;
